import { c as _c } from "react/compiler-runtime";
import React from "react";
import CompareSlider, { CompareSliderImage } from "@/components/client/CompareSlider/CompareSlider";
export default function ImageCompare(props) {
  const $ = _c(7);
  let t0;
  if ($[0] !== props.url1) {
    t0 = <CompareSliderImage src={props.url1} alt="Image one" />;
    $[0] = props.url1;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.url2) {
    t1 = <CompareSliderImage src={props.url2} alt="Image two" />;
    $[2] = props.url2;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <div className="image-compare mb-2"><CompareSlider itemOne={t0} itemTwo={t1} /></div>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}